import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { interval, Subscription } from 'rxjs';
import moment from 'moment';

@Component({
    selector: 'formly-timer-type',
    template: `
    <p>{{ formattedTime }}</p>
  `
})
export class TimerType extends FieldType implements OnInit, OnDestroy {
    private timerSubscription?: Subscription;
    private startTime?: moment.Moment;
    formattedTime: string = '00:00:00';

    constructor(private cdr: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        this.startTime = moment();
        this.startTimer();

        this.field.options?.fieldChanges?.subscribe(changes => {
            if (this.field.model?.submitted) {
                this.stopTimer();
            }
        });
    }

    private startTimer() {
        this.timerSubscription = interval(1000).subscribe(() => {
            const duration = moment.duration(moment().diff(this.startTime));
            this.formattedTime = moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
            this.formControl.setValue(this.formattedTime);
            this.cdr.detectChanges();
        });
    }

    private stopTimer() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }

    ngOnDestroy() {
        this.stopTimer();
    }
}